import { CSSProperties } from 'react';

import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const cls1Style: CSSProperties = {
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeMiterlimit: 10,
  strokeWidth: 2,
  fill: 'none',
};

const DownloadIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 20 20',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <g>
      <line
        id="Line_222"
        style={cls1Style}
        x1="10"
        y1="3.01"
        x2="10"
        y2="10.99"
      />
      <path id="Path_2151" style={cls1Style} d="M14.9,8,10,12.93,5.1,8" />
      <line
        id="Line_223"
        style={cls1Style}
        x1="3.68"
        y1="16.99"
        x2="16.32"
        y2="16.99"
      />
    </g>
  </SvgIcon>
);

export default DownloadIcon;
